'use client';

import { Loader2 } from 'lucide-react';

interface InfiniteScrollTriggerProps {
  isLoading: boolean;
  hasNextPage: boolean;
  setTargetRef: (element: HTMLDivElement | null) => void;
}

export function InfiniteScrollTrigger({
  isLoading,
  hasNextPage,
  setTargetRef,
}: InfiniteScrollTriggerProps) {
  return (
    <div
      ref={setTargetRef}
      className="w-full flex justify-center items-center py-4"
    >
      {isLoading && <Loader2 className="h-6 w-6 animate-spin text-ihs-blue" />}
    </div>
  );
}
